import { z } from "zod";

/** Límites del modo demo (totales de la instalación). */
export const DEMO_LIMITS = { studies: 1, participations: 2, mediaItems: 10 } as const;

export interface DemoStatusDto {
  enabled: boolean;
  /** El servidor tiene contraseña root (DEMO_ROOT_PASSWORD): se puede cambiar desde Ajustes. */
  configurable: boolean;
  limits: typeof DEMO_LIMITS;
  usage: { studies: number; participations: number; mediaItems: number };
  updatedAt: string | null;
}

/** Estado público (pantallas de inicio de sesión y de participación). */
export interface PublicDemoDto {
  demoMode: boolean;
}

export const DemoModeToggle = z
  .object({
    enabled: z.boolean(),
    rootPassword: z.string().min(1).max(500),
  })
  .strict();
export type DemoModeToggle = z.infer<typeof DemoModeToggle>;
